import React, {PureComponent} from 'react';
import styles from './DateContainer.module.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import clsx from "clsx";

class DateField extends PureComponent {
  constructor(props) {
    super(props)
    const m = moment(props.value, 'MM/DD/YYYY', true);
    this.state = {
      ...props,
      date: m.isValid() ? m.toDate() : null
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const m = moment(this.props.value, 'MM/DD/YYYY', true);
      this.setState({
        date: m.isValid() ? m.toDate() : null
      })
    }
  }

  handleChange = (date) => {
    this.setState({date})
    const format = 'MM/DD/YYYY'
    const value = date === null ? '' : moment(date).format(format)
    let e = {target: { value, name: this.props.inputId}}
    this.props.handleInputs(e)
  }

  handleChangeRaw = (e) => {
    // prevent react-datepicker from resetting the input while typing
    if (e && e.preventDefault) e.preventDefault();
    const format = 'MM/DD/YYYY';
    const raw = e.target.value;
    if (raw === undefined || raw === null || raw === '') {
      this.setState({ date: null });
      const ev = { target: { value: '', name: this.props.inputId } };
      this.props.handleInputs(ev);
      return;
    }
    const m = moment(String(raw).trim(), format, true);
    if (m.isValid()) {
      const d = m.toDate();
      this.setState({ date: d });
      const ev = { target: { value: m.format(format), name: this.props.inputId } };
      this.props.handleInputs(ev);
    }
  }

  render() {
    const {input, inputId} = this.props;
    const {date} = this.state

    let minDate = new Date();
    minDate.setFullYear( minDate.getFullYear() - 100 );

    return (
      <div className={styles.root}>

          <DatePicker
            showYearDropdown
            minDate={minDate}
            maxDate={new Date()}
            dateFormat="MM/dd/yyyy"
            name={inputId}
            placeholderText={`${input.yup ? '*' : ''}${input.label}`}
            selected={date}
            onChange={this.handleChange}
            onChangeRaw={this.handleChangeRaw}
            className={clsx({
              [styles.field]: true,
              [styles.error]: input.error
            })}
          />
      </div>

    );
  }
}

export default DateField;